import api from './api';

export const specialDayService = {
  // Get all special days
  getSpecialDays: async (params = {}) => {
    const response = await api.get('/special-days', { params });
    return response.data;
  },

  // Get single special day
  getSpecialDay: async (id) => {
    const response = await api.get(`/special-days/${id}`);
    return response.data;
  },

  // Create special day
  createSpecialDay: async (data) => {
    const response = await api.post('/special-days', data);
    return response.data;
  },

  // Update special day
  updateSpecialDay: async (id, data) => {
    const response = await api.put(`/special-days/${id}`, data);
    return response.data;
  },

  // Delete special day
  deleteSpecialDay: async (id) => {
    const response = await api.delete(`/special-days/${id}`);
    return response.data;
  }
};
